import { Component, ElementRef, ViewChild } from '@angular/core';
import { CsvData } from 'src/models/CsvData.interface';
import Swal from 'sweetalert2';
import { CrmService } from '../services/crm.service';

@Component({
  selector: 'app-crm-bulk-clients',
  templateUrl: './crm-bulk-clients.component.html',
  styleUrls: ['./crm-bulk-clients.component.css'],
})
export class CrmBulkClientsComponent {
  @ViewChild('csvInput') csvInput!: ElementRef<HTMLInputElement>;
  selectedFile?: File;
  isLoading: boolean = false;
  csvData: CsvData = { data: [], errors: [] };

  constructor(private crmService: CrmService) { }

  onFileSelected(event: Event) {
    const element = event.target as HTMLInputElement;
    const file = element.files?.[0];
    if (file) {
      this.selectedFile = file;
    }
  }

  triggerFileInput() {
    this.csvInput.nativeElement.click();
  }

  uploadFile() {
    if (this.selectedFile) {
      this.isLoading = true;
      this.crmService.bulkCreateClients(this.selectedFile).subscribe({
        next: (response: CsvData) => {
          this.isLoading = false;
          this.csvData = response;
          if (response.data.length > 0) {
            Swal.fire({
              title: 'Clientes creados correctamente',
              icon: 'success',
              confirmButtonText: 'OK',
              confirmButtonColor: '#F95A14',
              text: `Se han creado ${response.data.length} clientes`,
            });
          }
          if (response.errors.length > 0) {
            Swal.fire({
              title: 'Alerta',
              icon: 'warning',
              confirmButtonText: 'OK',
              confirmButtonColor: '#F95A14',
              text: `Clientes se crearon correctamente pero con errores. Consulte los detalles en el sistema.`,
            });
          }
        },
        error: (error) => {
          this.isLoading = false;
          Swal.fire({
            title: 'Error',
            icon: 'error',
            text: 'Ha ocurrido un error al procesar la solicitud. Por favor, inténtalo de nuevo.',
          });
        },
      });
    }
  }
}
